import { defineMessages } from 'react-intl-next';

export const sharedI18n = defineMessages({
	addToNote: {
		id: 'note-contextual-create.add-to-note-button',
		defaultMessage: 'Add to note',
		description: 'Button to open a dropdown menu with options to add highlighted content to note',
	},
	createNote: {
		id: 'note-contextual-create.create-note-button',
		defaultMessage: 'Create a note',
		description: 'Button to create a note from the selected content',
	},
	untitledNote: {
		id: 'note-contextual-create.untitled-note',
		defaultMessage: 'Untitled note',
		description: 'Label for an untitled note',
	},
});
